<div class="bg-white m-2">
  <div class="border-bottom border-gray">
    <button type="button" class="btn btn-icons float-end" aria-label="Close" (click)="cancel()">
      <span aria-hidden="true">&times;</span>
    </button>
    <h3 class="text-secondary pb-2">Signature bénéficiaire</h3>
  </div>
  <div class="modal-body">
    <form [formGroup]="assessmentSignatureForm" class="col-12">
      <div class="mb-4">
        <p><strong>Je m'engage : </strong></p>
        <ul>
          <li>
            En cas d’orientation vers France Travail (accompagnement de droit commun ou accompagnement global), à maintenir mon inscription et
            poursuivre activement mes démarches de recherche d’emploi
          </li>
          <li>
            En cas d’orientation vers un parcours social ou socioprofessionnel, à me rendre à mon premier RDV d’accompagnement qui me sera envoyé à
            l’issue de cette « Rencontre Information Orientation »
          </li>
        </ul>
      </div>

      <div class="row mb-4">
        <p><strong>Entretien réalisé par téléphone : </strong></p>
        <div class="col-4 col-lg-2">
          <div class="form-check form-check-inline">
            <input id="yes" type="radio" class="form-check-input" formControlName="byPhone" value="true" />
            <label for="yes" class="form-check-label">Oui</label>
          </div>
        </div>
        <div class="col-4 col-lg-2">
          <div class="form-check form-check-inline">
            <input id="no" type="radio" class="form-check-input" formControlName="byPhone" value="false" />
            <label for="no" class="form-check-label">Non</label>
          </div>
        </div>
      </div>

      <div *ngIf="displaySignaturePad" class="mx-auto mb-4" style="border: 1px solid red" [style.width]="width + 'px'" [style.height]="height + 'px'">
        <ng-signaturepad #signaturePad [width]="width" [height]="height"></ng-signaturepad>
      </div>

      <div class="d-flex flex-row-reverse px-3" *ngIf="!isEmpty">
        <button type="button" role="button" class="shadow-none btn btn-link text-decoration-none" (click)="clear()">Effacer</button>
      </div>

      <div class="row mt-3">
        <div class="d-grid col-6 p-0 pe-1">
          <button class="btn btn-secondary d-flex justify-content-center" type="button" (click)="cancel()">Annuler</button>
        </div>
        <div class="d-grid col-6 p-0 ps-1">
          <button
            class="btn btn-primary d-flex justify-content-center"
            type="button"
            [disabled]="(displaySignaturePad && isEmpty) || !assessmentSignatureForm.valid"
            (click)="accept()"
          >
            Valider
          </button>
        </div>
      </div>
    </form>
  </div>
</div>
